/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import { getSelectedPath } from './utils';
import DashboardComponent from 'modules/me/dashboard/main';


export const index = (context, next) => {
    context.primary = <DashboardComponent />;
    next();
};
